const normalizeString = (value) => String(value == null ? '' : value).trim();

export const pickRealtimeReadCount = (payload = {}, fallback = 1) => {
  const message = payload?.message && typeof payload.message === 'object' ? payload.message : {};
  const parsed = Number(
    message.read_count ??
      message.readCount ??
      payload.read_count ??
      payload.readCount
  );
  if (!Number.isFinite(parsed) || parsed < 0) return fallback;
  return Math.round(parsed);
};

const resolveMessageId = (message = {}) =>
  normalizeString(message.id || message.message_id || message.messageId);

const resolveReaderMeta = (reader = {}) => ({
  type: normalizeString(reader.readerType || reader.reader_type).toLowerCase(),
  id: normalizeString(reader.readerId || reader.reader_id),
});

const resolveEventSenderMeta = (message = {}) => {
  const messageType = normalizeString(message.message_type || message.messageType).toLowerCase();
  if (messageType === 'admin_message') {
    return {
      type: 'admin',
      id: normalizeString(message.admin_user_id || message.adminUserId),
    };
  }
  if (messageType === 'artist_message') {
    return {
      type: 'artist',
      id: normalizeString(message.artist_id || message.artistId || message.artist_user_id || message.artistUserId),
    };
  }
  return { type: '', id: '' };
};

const resolveGroupSenderMeta = (message = {}) => {
  const senderType = normalizeString(message.sender_type || message.senderType).toLowerCase();
  if (senderType === 'admin') {
    return {
      type: 'admin',
      id: normalizeString(message.admin_user_id || message.adminUserId),
    };
  }
  if (senderType === 'artist') {
    return {
      type: 'artist',
      id: normalizeString(message.artist_user_id || message.artistUserId || message.artist_id || message.artistId),
    };
  }
  return { type: senderType, id: '' };
};

const resolveSenderMeta = (message = {}, scope = 'event') =>
  scope === 'group' ? resolveGroupSenderMeta(message) : resolveEventSenderMeta(message);

export const patchMessageReadCountsByIds = (messages = [], messageIds = [], reader = {}, options = {}) => {
  const idSet = new Set(
    (Array.isArray(messageIds) ? messageIds : [])
      .map((id) => normalizeString(id))
      .filter(Boolean)
  );
  if (!idSet.size) return messages;

  const readerMeta = resolveReaderMeta(reader);
  const scope = options.scope === 'group' ? 'group' : 'event';
  let changed = false;

  const next = messages.map((message) => {
    const messageId = resolveMessageId(message);
    if (!messageId || !idSet.has(messageId)) return message;

    const sender = resolveSenderMeta(message, scope);
    if (readerMeta.type && readerMeta.id && sender.type === readerMeta.type && sender.id === readerMeta.id) {
      return message;
    }

    const current = Number(message?.read_count);
    changed = true;
    return {
      ...message,
      read_count: (Number.isFinite(current) && current >= 0 ? Math.round(current) : 1) + 1,
    };
  });

  return changed ? next : messages;
};

// NOTE: 旧 mergeChatMessagesPreservingReadCount(連結順維持・ソートなしのグループ用 merge)は
// timelineMerge.mergeMessages(ソート保証+read_count 単調増加)へ統合し削除(WP-W2)。
